import { GreetingProtectionTypeEnum } from "../types";
import BaseGreetingProtection from "./BaseGreetingProtection";

export default class MathCaptchaGreetingProtection extends BaseGreetingProtection {
  type: GreetingProtectionTypeEnum = GreetingProtectionTypeEnum.MathCaptcha
}
